import { authHeader } from '../helpers';

export const userService = {
    login,
    logout,
    getAll
};

export const config ={
    apiUrl:"https://app.mayashop.ovh/api/auth.php"
};

function login(username, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'login_auth=1&login=' + username + '&passwd=' + password
    };

    return fetch(`${config.apiUrl}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            // login successful if there's a user in the response
            if (data) {
                // store user details and basic auth credentials in local storage
                // to keep user logged in between page refreshes
                if (data.out !== 0){
                    data.authdata = data.jwt //window.btoa(username + ':' + password);
                    localStorage.setItem('data', JSON.stringify(data));
                }else{
                    data = null;
                }

            }

            return data;
        });
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('data');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`${config.apiUrl}/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        debugger;
        console.log(text);
        const data = text && JSON.parse(text);
        console.log(data);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                window.location.reload(true);
            }

            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}